import {
  AndroidOutlined,
  ClockCircleOutlined,
  CloseCircleOutlined,
  CopyOutlined,
  DeleteOutlined,
  DownloadOutlined,
  EyeOutlined,
  GroupOutlined,
  MailOutlined,
  PlayCircleOutlined,
  SyncOutlined,
  UnorderedListOutlined,
  UserAddOutlined,
} from '@ant-design/icons';
import {
  ActiveConfigIcon,
  BotsMenuIcon,
  ErrorIcon,
  InActiveConfigIcon,
  RunningIcon,
} from '../assets/index';

export const processStatus = [
  { id: 0, value: 'Pending' },
  { id: 1, value: 'Running' },
  { id: 2, value: 'Executed' },
];

export const BotAgentConstant = {
  name: 'Agent',
  text: 'Download Agent',
  downloadingName: 'AgentSetup.msi',
};

export const BotStudioConstant = {
  name: 'BotStudio',
  downloadingName: 'StudioSetup.msi',
};

export const weekDays = [
  { label: 'Sunday', value: 0 },
  { label: 'Monday', value: 1 },
  { label: 'Tuesday', value: 2 },
  { label: 'Wednesday', value: 3 },
  { label: 'Thursday', value: 4 },
  { label: 'Friday', value: 5 },
  { label: 'Saturday', value: 6 },
];

export const months = [
  { label: 'Jan', value: 1 },
  { label: 'Feb', value: 2 },
  { label: 'Mar', value: 3 },
  { label: 'Apr', value: 4 },
  { label: 'May', value: 5 },
  { label: 'Jun', value: 6 },
  { label: 'Jul', value: 7 },
  { label: 'Aug', value: 8 },
  { label: 'Sep', value: 9 },
  { label: 'Oct', value: 10 },
  { label: 'Nov', value: 11 },
  { label: 'Dec', value: 12 },
];

export const dates = Object.freeze([
  1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27,
  28, 29, 30, 31,
]);

export const stringConstant = Object.freeze({
  CompanyRegistration: 'Company Registration',
  RegisterCompanyBtnText: 'Register Company',
  AddCompanyBtnText: 'Add Company',
  AddUserBtn: { component: <UserAddOutlined />, text: 'Add User' },
  AddBotBtn: { component: <AndroidOutlined />, text: 'Add Bot' },
  AddToGroupBtn: { component: <GroupOutlined />, text: 'Add To Group' },
  CancelProcessesBtn: { component: <CloseCircleOutlined />, text: 'Cancel' },
  AddCustomerAdminTitle: 'Add Customer Admin',
  EditCustomerAdminTitle: 'Edit Customer Admin',
  UserRegistration: 'User Registration',
  AddCustomerAdminText: 'Add Customer Admin',
  CustomerAdminText: 'Customer Admins',
  RegisterAdminBtnText: 'Register Admin',
  companyTitle: 'Company Details',
  DeleteCompanyTitle: 'Delete Company',
  DeleteUserTitle: 'Delete User',
  DeleteBotTitle: 'Delete Bot',
  DeleteScheduleTitle: 'Delete Schedule Plan',
  ForgotPasswordTitle: 'Forgot Password',
  ForgotPasswordSubmitBtnText: 'Send Reset Password Link',
  ResetPasswordTitle: 'Reset Password',
  ResetPasswordSubmitBtnText: 'Update Password',
  ForgotPasswordNoteText: 'You will recieve a reset password link on below email!',
  WaitingTimeText: 'Please wait...',
  ForgotPasswordLinkSentText: 'The link has been sent to your registered email!',
  ResetPasswordSuccessText: 'Password has been reset successfully!',
  UpdateBotTitle: 'Update Bot',
  DeleteTokenTitle: 'Delete Token',
  DeleteAgentTitle: 'Delete Agent',
  LoginButtonText: 'Login',
  SendAgainButtonText: 'Resend',
  DownloadBotFileButtonConstant: 'Download Bot File',
  AddRecipientsEmail: 'Add Additional recipients’ email',
  EnableEmailSubscriptionInfoIconText:
    'Enabling this checkbox will allow you to email notification subscriptions for bots and processes!',
  OnlyTenRecipientsAllowed: 'Only 10 recipients are allowed!',
  updateCompany: 'Update',
  updateUser: 'Update',
  sendResetLink: 'Reset Password Link',
  missingConfigurationTooltipText:
    'Please add required configurations for bot from View Bots section!',
  OnlyAdminAndCreatorCanUpdateABot: 'Only admin and creator can update a bot!',
  OnlyAdminAndCreatorCanDeleteABot: 'Only admin and creator can delete a bot!',
  OnlyAdminCanDeleteUserGroup: 'Sub-admin cannot delete a user group!',
  yourBotIsExpiredContactSuperAdmin: 'Your bot is expired, contact admin!',
  runRepeatedlyValidationMessage: 'Please select frequency or repeat duration for the process!',
  runRepeatedlyselectWeekDay: 'Please select day Of week!',
  runRepeatedlySelectMonth: 'Please select month!',
  runRepeatedlySelectMonthDay: 'Please select day of month!',
  DeleteGroupTitle: 'Delete Group',
  AddUsersToGroup: 'Add users to a group!',
  AddUsersToThisGroup: 'Add users to this group!',
  AtleastOneUser: 'There must be atleast one user!',
  UsersCanBeOfASingleCompany: 'Users can be selected from a single company only!',
  EnableNotificationForProcess: 'Enable notification for this process!',
  DisableNotificationForProcess: 'Disable notification for this process!',
  NotificationsAreUnsubscribedAtCompanyLevel: 'Notifications are unsubscribed at company level!',
  AgentIsBusy: 'Agent is busy!',
  ReadableOnly: 'Readable only!',
  FirstSelectThisUser: 'Please first select this user!',
  AddUsersToAssociateWithThisGroupOptional: 'Please add users to associate with this group!',
  EveryUserHasBeenSelected: 'Every user has been selected!',
  CancelProcessesTitle: 'Cancel Processes',
  PendingProcessesPopUpMessage: 'Are you sure to delete "Processes"?',
  FirstSelectAPendingProcess: 'Please first select a pending process!',
  OnlyPendingProcessesCanBeCancelled: 'Only pending processes can be cancelled!',
  pendingProcessesDoNotHaveLogs: "Processes in pending state don't have logs!",
  remaingingDaysForExpiration: 'days remaining to expire!',
  OnlyCustomerAdminCanNotBeDeleted: 'Only customer admin can not be deleted',
  noActiveBot: 'No active bot is available!',
  selectFrequency: 'Please select a frequency!',
  selectMinutes: 'Please select minutes!',
  selectHours: 'Please select hours!',
  selectAtTime: 'Please select a time!',
  selectWeekDays: 'Please select week days!',
  selectMonths: 'Please select months!',
  selectWeekDaysOfMonths: 'Please select week days for the selected months!',
  selectDatesOfMonths: 'Please select dates for the selected months!',
  selectDayOrDateWise: 'Please select either day wise or date wise!',
  OnlyAdminCanDeleteABot: 'Sub-admin cannot delete a bot!',
  onlySuperAdminCanDeleteUser: 'Sub-admin cannot delete a user!',
  onlySuperAdminCanDeleteAgent: 'Sub-admin cannot delete an agent!',
  subAdminCannotUpdateSuperAdmin: 'Sub-admin cannot update a Super Admin!',
});

export const pageSize = 5;
export const pageSizeForProcessHistoryLogs = 3;
export const portTestEmail = 993;

export const routeConstant = Object.freeze({
  USER_VIEW_PATH: '/controlroom/user/view',
  COMPANY_VIEW_PATH: '/controlroom/company/view',
  COMPANY_DETAILS_PATH: '/controlroom/company/details',
  COMPANY_REGISTRATION_PATH: '/controlroom/company/register',
  USER_REGISTRATION_PATH: '/controlroom/user/registration',
  USER_DETAILS_PATH: '/controlroom/user/details',
  SCHEDULE_DETAILS_PATH: '/controlroom/process/schedule/details',
  SCHEDULE_HISTORY_DETAILS_PATH: '/controlroom/process/schedule/history/details',
  CONTROL_ROOM_BASE_PATH: '/controlroom',
  USER_LOGIN_PATH: '/login',
  FORGOT_PASSWORD_PATH: '/account/forgot-password',
  RESET_PASSWORD_PATH: '/account/reset-password',
  RESET_PASSWORD_EXPIRED_PATH: '/account/reset-password-expired',
  LOGGEDIN_RESET_PASSWORD_PATH: '/controlroom/account/reset-password',
  BOT_DETAILS_PATH: '/controlroom/bots/details',
  BOT_VIEW_PATH: '/controlroom/bots/view',
  BOT_REGISTRATION_PATH: '/controlroom/bots/create',
  GROUP_REGISTRATION_PATH: '/controlroom/group/registration',
  GROUPS_VIEW: '/controlroom/groups',
  GROUP_DETAILS_PATH: '/controlroom/groups/details',
  SCHEDULE_VIEW_PATH: '/controlroom/process/schedule/all',
  SCHEDULE_HISTORY_VIEW_PATH: '/controlroom/process/schedule/history',
  CURRENT_PROCESS_LOGS_PATH: '/controlroom/process',
  PROCESS_DETAILS_PATH: '/controlroom/process',
  HISTORY_LOGS_PATH: '/controlroom/process/logs',
  AGENT_VIEW_PATH: '/controlroom/agents',
});

export const BotOperation = ['View', 'Update', 'Delete'];
export const BotOperationComponentWithAction = [
  { component: <EyeOutlined />, action: 'View' },
  { component: <SyncOutlined />, action: 'Update' },
  { component: <DeleteOutlined />, action: 'Delete' },
];
export const BotOpertionObject = BotOperation.reduce((prev, curr) => {
  prev[curr] = curr;
  return prev;
}, {});

export const TokensOperation = ['Copy', 'Delete', 'Download'];
export const TokensOperationComponentWithAction = [
  { component: <CopyOutlined />, action: 'Copy' },
  { component: <DeleteOutlined />, action: 'Delete' },
  { component: <DownloadOutlined />, action: 'Download' },
];
export const TokensOpertionObject = TokensOperation.reduce((prev, curr) => {
  prev[curr] = curr;
  return prev;
}, {});

export const UserOperation = ['View', 'Update', 'Delete', 'Reset Link'];
export const UserOperationComponentWithAction = [
  { component: <EyeOutlined />, action: 'View' },
  { component: <SyncOutlined />, action: 'Update' },
  { component: <DeleteOutlined />, action: 'Delete' },
  { component: <MailOutlined />, action: 'Reset Link' },
];
export const UserOpertionObject = UserOperation.reduce((prev, curr) => {
  prev[curr] = curr;
  return prev;
}, {});

export const CompanyOperation = ['View', 'Update', 'Delete'];
export const CompanyOperationComponentWithAction = [
  { component: <EyeOutlined />, action: 'View' },
  { component: <SyncOutlined />, action: 'Update' },
  { component: <DeleteOutlined />, action: 'Delete' },
];
export const CompanyOpertionObject = CompanyOperation.reduce((prev, curr) => {
  prev[curr] = curr;
  return prev;
}, {});

export const AgentOperation = ['Run', 'Schedule', 'Delete'];
export const AgentOperationComponentWithAction = [
  { component: <PlayCircleOutlined />, action: 'Run' },
  { component: <ClockCircleOutlined />, action: 'Schedule' },
  { component: <DeleteOutlined />, action: 'Delete' },
];

export const ProcessOperationComponentWithAction = [
  { component: <CloseCircleOutlined />, action: 'Cancel' },
];
export const AgentOpertionObject = AgentOperation.reduce((prev, curr) => {
  prev[curr] = curr;
  return prev;
}, {});

export const ScheduleOperation = ['View', 'Delete'];
export const ScheduleOperationComponentWithAction = [
  { component: <EyeOutlined />, action: 'View' },
  { component: <DeleteOutlined />, action: 'Delete' },
];
export const ScheduleOpertionObject = ScheduleOperation.reduce((prev, curr) => {
  prev[curr] = curr;
  return prev;
}, {});

export const ScheduleHistoryOperation = ['View', 'Reschedule', 'Delete'];
export const ScheduleHistoryOperationComponentWithAction = [
  { component: <EyeOutlined />, action: 'View' },
  { component: <ClockCircleOutlined />, action: 'Reschedule' },
];
export const ScheduleHistoryOpertionObject = ScheduleHistoryOperation.reduce((prev, curr) => {
  prev[curr] = curr;
  return prev;
}, {});

export const GroupOperation = ['View', 'Update', 'Delete'];
export const GroupOperationComponentWithAction = [
  { component: <EyeOutlined />, action: 'View' },
  { component: <SyncOutlined />, action: 'Update' },
  { component: <DeleteOutlined />, action: 'Delete' },
];
export const GroupOpertionObject = GroupOperation.reduce((prev, curr) => {
  prev[curr] = curr;
  return prev;
}, {});

export const currentProcessOperation = ['Cancel', 'Details', 'Logs'];
export const currentProcessOperationComponentWithAction = [
  { component: <CloseCircleOutlined />, action: 'Cancel' },
  // { component: <EyeOutlined />, action: "Details" },
  { component: <UnorderedListOutlined />, action: 'Logs' },
];
export const currentProcessOperationObject = currentProcessOperation.reduce((prev, curr) => {
  prev[curr] = curr;
  return prev;
}, {});

export const historyLogsOperation = ['Details', 'Logs'];
export const historyLogsOperationComponentWithAction = [
  // { component: <EyeOutlined />, action: "Details" },
  { component: <UnorderedListOutlined />, action: 'Logs' },
];
export const historyLogsOperationObject = historyLogsOperation.reduce((prev, curr) => {
  prev[curr] = curr;
  return prev;
}, {});

export const botStatusType = Object.freeze(['Active', 'inActive']);
export const processActionType = Object.freeze({
  Cancel: 'Cancel',
});
export const processFilterOptions = Object.freeze({
  Bot: 'Bot',
  Status: 'Status',
  User: 'User',
});
export const processHistoryFilterOptions = Object.freeze({
  Bot: 'Bot',
  Company: 'Company',
});

export const processCurrentStatusFilterOptions = Object.freeze({
  Agent: 'Agent',
  Bot: 'Bot',
  Company: 'Company',
  Status: 'Status',
  ScheduleType: 'ScheduleType',
});

export const processScheduleFilterOptions = Object.freeze({
  Agent: 'Agent',
  Bot: 'Bot',
  Company: 'Company',
  Type: 'Type',
});

export const botFilterOptions = Object.freeze({
  Company: 'Company',
  Status: 'Status',
});

export const agentFilterOptions = Object.freeze({
  Company: 'Company',
  Status: 'Status',
});

export const tokenFilterOptions = Object.freeze({
  Company: 'Company',
  Status: 'Status',
  Type: 'Type',
});

export const userFilterOptions = Object.freeze({
  Company: 'Company',
  Group: 'Group',
  Role: 'Role',
  Status: 'Status',
});

export const dashboardFilterOptions = Object.freeze({
  Company: 'Company',
  Bot: 'Bot',
});

export const emailConfigurationsFilterOptions = Object.freeze({
  Company: 'Company',
  Status: 'Status',
});

export const toastContainerProps = {
  // position: "top-right",
  autoClose: 2000,
  limit: 1,
  // hideProgressBar: false,
  // newestOnTop: false,
  // closeOnClick: true,
  // rtl: false,
  // pauseOnFocusLoss: false,
  // draggable: false,
  // pauseOnHover: true,
  // theme: "light"
};

export const toastifyProps = {
  position: 'top-right',
  autoClose: 2000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
  theme: 'light',
};

export const toastType = Object.freeze({
  info: 'info',
  success: 'success',
  warning: 'warning',
  error: 'error',
  default: 'default',
});

export const toastTheme = Object.freeze({
  light: 'light',
  dark: 'dark',
  colored: 'colored',
});

export const toastPosition = Object.freeze({
  topLeft: 'top-left',
  topRight: 'top-right',
  topCenter: 'top-center',
  bottomLeft: 'bottom-left',
  bottomRight: 'bottom-right',
  bottomCenter: 'bottom-center',
});

export const tokenValidationPattern = Object.freeze({
  namePattern: /^[a-zA-Z\d\s]+$/,
});

export const companyValidationPattern = Object.freeze({
  namePattern: /^[a-zA-Z\d\s]+$/,
  addressPattern: /^[a-zA-Z0-9\s,#_/]+$/,
  whiteSpaceValidation: /^(?!.*(?<! ) {2,}(?! ))/,
});
export const companyValidationMessages = Object.freeze({
  namePatternMessage: 'Name can only include letters and numbers!',
  nameLengthMessage: 'Name must be upto 60 characters!',
  nameMinimumLengthMessage: 'Name must contain at least 2 characters!',
  addressMinimumLengthMessage: 'Address must contain at least 10 characters!',
  addressMaximumLengthMessage: 'Address must be upto 60 characters!',
  whiteSpaceValidationMessage: 'More than one consecutive space is not allowed!',
});

export const userValidationPattern = Object.freeze({
  namePattern: /^[a-zA-Z\s]+$/,
  whiteSpaceValidation: /^(?!.*(?<! ) {2,}(?! ))/,
  emailPattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
});
export const emailConfigurationValidationPattern = Object.freeze({
  namePattern: /^[a-zA-Z\s]+$/,
  whiteSpaceValidation: /^(?!.*(?<! ) {2,}(?! ))/,
});

export const passwordValidationPattern = Object.freeze({
  uppercaseRegExp: /(?=.*?[A-Z])/,
  lowercaseRegExp: /(?=.*?[a-z])/,
  digitsRegExp: /(?=.*?[0-9])/,
  specialCharRegExp: /(?=.*?[#?!@$%^&*-])/,
  minLengthRegExp: /.{8,}/,
  spaces: /^\S+$/,
  maxLengthRegExp: /^.{0,12}$/,
  validPasswordRegExp: /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-])(?!.*\s).{8,12}$/,
});

export const userValidationMessages = Object.freeze({
  namePatternMessage: 'Name can only include letters!',
  nameLengthMessage: 'Name must be upto 32 characters!',
  nameMinimumLengthMessage: 'Name must contain at least 2 characters!',
  whiteSpaceValidationMessage: 'More than one consecutive space is not allowed!',
});

export const botValidationPattern = Object.freeze({
  titlePattern: /^[a-zA-Z0-9\s]+$/,
  whiteSpaceValidation: /^(?!.*(?<! ) {2,}(?! ))/,
  descriptionPattern: /^[a-zA-Z0-9\s,#_/]+$/,
});

export const botValidationMessages = Object.freeze({
  titlePatternMessage: 'Title can only include letters, spaces and numbers!',
  titleLengthMessage: 'Title must be in range of 2-32',
  descriptionMinLengthMessage: 'Description must contain at least 10 characters!',
  descriptionPatternMessage: 'Description can only include letters, numbers and spaces!',
  whiteSpaceValidationMessage: 'More than one consecutive space is not allowed!',
  descriptionMessage: 'Special characters are not allowed!',
});

export const agentCreationTokenMesaages = Object.freeze({
  tokenCreatedSuccessfully: 'Token created successfully!',
});

export const maximumBotRunners = Object.freeze({
  message: 'Value must start with 1!',
});

export const minimumBotStudios = Object.freeze({
  message: 'Minimum value must be start with 0!',
});

export const regex = Object.freeze({
  emailValidationRegex:
    /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i,
  integerValidationPattern: /^-?\d+$/,
  integerValidationMessage: 'Only integer numbers are accepted!',
});

export const numberOfAdditionalRecipients = 10;
export const SEED_ADMIN_EMAIL = 'rpacontrolroom@gmail.com';

export const registrationType = Object.freeze({
  SuperAdmin: 'Super Admin',
  OtherUser: 'Other User',
});

export const eventType = Object.freeze({
  agent: 'agent',
  process: 'process',
  processExecutionLog: 'processExecutionLog',
});
export const eventOperation = Object.freeze({
  insert: 'insert',
  update: 'update',
});

export const requiredBotsConfigurations = Object.freeze({
  parametersSize: 15,
  valuesSize: 30,
  requiredMessage: 'This field is required!',
  parameterLengthExceedingMessage: "Length shouldn't be exceeded 15 characters!",
  valueLengthExceedingMessage: "Length shouldn't be exceeded 30 characters!",
  checkEncryptionMessage: 'Check if you want to save encrypted value!',
  inValidParametersMessage: "Some parameters haven't been added!",
});

export const processesStatuses = Object.freeze({
  pending: 0,
  running: 1,
  executed: 2,
  failed: 3,
  canceled: 4,
  agentDisconnected: 5,
});

export const pieChartOptions = {
  labels: ['Successful Processes', 'Failed Processes', 'Terminated Processes'],
  backgroundColor: ['#7CC05B', '#FF0000', '#C2C2C1'],
  borderWidth: 1,
};

export const groupValidationPattern = Object.freeze({
  namePattern: /^[a-zA-Z\d\s]+$/,
  whiteSpaceValidation: /^(?!.*(?<! ) {2,}(?! ))/,
});

export const agentMessage = Object.freeze({
  checkFields: 'Please check selected fields!',
});

export const homePageMessage = Object.freeze({
  inputEmail: 'Please input Email!',
  inputValidEmail: 'Please enter valid email address!',
});

export const userFormModalMessage = Object.freeze({
  inputEmail: 'Please input your email address!',
  selectUserRole: 'Please select user role!',
});

export const updateCompanyDetailsMessage = Object.freeze({
  inputCompanyName: 'Please input your company name!',
  inputValidCompanyName: 'The input is not a valid company name!',
  inputCompanyAddress: 'Please input your company address!',
});

export const updateGroupDetailsMessage = Object.freeze({
  inputName: 'Please input name!',
});

export const updateUserDetailsMessage = Object.freeze({
  inputFullName: 'Please input your full name!',
  inputEmailAddress: 'Please input your email address!',
});

export const otherUserMessage = Object.freeze({
  inputFullName: 'Please input your full name!',
  inputEmailAddress: 'Please input your email address!',
  selectGroup: 'Please select a group!',
  selectCompany: 'Please select a company!',
  inputPassword: 'Please input your password!',
});
export const otherEmailConfigurationMessage = Object.freeze({
  inputFullName: 'Please input your full name!',
  inputEmailAddress: 'Please input your email address!',
  selectGroup: 'Please select a group!',
  selectCompany: 'Please select a company!',
  inputPassword: 'Please input your password!',
  selectHost: 'Please select a host!',
  inputSecret: 'Please input secret!',
});

export const superAdminMessage = Object.freeze({
  inputFullName: 'Please input your full name!',
  inputEmailAddress: 'Please input your email address!',
});

export const processSchedulerMessage = Object.freeze({
  selectBot: 'Please select bot!',
  selectTimezone: 'Please select timezone!',
  selectStartDate: 'Please select start date!',
  selectValidDateAndTime: 'Please select valid date & time!',
  selectValidDate: 'Please select valid date!',
  selectEndDate: 'Please select end date!',
  selectDateRange: 'Please select date range!',
  checkRepeatEvery: 'Please check repeat every!',
  unCheckRepeatEvery: 'Please uncheck repeated every!',
  defaultSelect: 'Please select previous input!',
  selectConfiguration: 'Please select configuration!',
  selectOperation: 'Please select an operation!',
  selectCriteria: 'Please select a criteria!',
  inputCriteriaValue: 'Please input a criteria value!',
  inputValidEmail: 'Please enter a valid email!',
  inputEmail: 'Please enter an email!',
  inputSubjectLine: 'Input a subject line!',
  inputText: 'Input text!',
  clickOnAddButton: 'Please click on add button!',
  emptyInterval: ' Please enter an interval!',
});

export const userReducerMessage = Object.freeze({
  userUpdate: 'User updated successfully!',
  userDelete: 'User deleted successfully!',
});

export const tokenReducerMessage = Object.freeze({
  tokenCopied: 'Token copied successfully!',
});

export const botTypes = [
  { name: 'Manual', value: 1 },
  { name: 'Automated', value: 2 },
];

export const idleSessionTimeout = Object.freeze({
  message: 'Session Expired',
  milliseconds: 15 * 60 * 1000,
});

export const themeColor = {
  toolTipColor: 'white',
  toolTipTextColor: 'black',
  buttonColor: '#7A5CDE',
  blackColor: '#000000',
  sideBarFuchsiaBlue: '#8258C9',
  buttonOnHoverColor: '#3F108A',
  warningColor: '#ffd907',
  whiteBackground: '#fff',
  silverBoder: '#ccc',
  RedColor: 'red',
  tundoraColor: '#414141',
  blackShadeColor: '#303030',
  silverChaliceColor: '#B2B2B2',
  testBtnBg: '#1C4E80',
  versionColor: '#bbb',
  orange: '#FF8000',
};

export const googleAccountInstructions = (
  <div>
    1. Go to your{' '}
    <a href="https://myaccount.google.com/?pli=1" target="_blank" rel="noopener noreferrer">
      Google Account
    </a>
    .<br />
    2. Select <b>Security</b>.<br />
    3. Under "Signing in to Google," select <b>2-Step Verification</b>.<br />
    4. At the bottom of the page, select <b>App passwords</b>.<br />
    5. Enter a name that helps you remember where you’ll use the app password.
    <br />
    6. Select <b>Generate</b>.<br />
    7. To enter the app password, follow the instructions on your screen. The app password is the
    16-character code that generates on your device.
    <br />
    8. Select <b>Done</b>.
  </div>
);

export const interpollingTimeGapTypeConstant = {
  m: 'Minute',
  h: 'Hour',
};

export const emailConfigurationMessages = {
  notAllowedToUpdate: 'You are not allowed to update this email configuration!',
  notAllowedToDelete: 'Sub-admins are not allowed to delete the email configuration!',
};

export const hostConstants = [
  {
    title: 'Gmail',
    value: 'gmail.com',
  },
];

export const configEncryptionDecryption = {
  ALGORITHM: `${process.env.REACT_APP_ALGORITHM}`,
  SECRET: `${process.env.REACT_APP_PASSWORD}`,
};

export const roleDescription = {
  superAdminDescription:
    'A super admin possesses unrestricted access and control over all system functionalities.',
  customerAdminDescription:
    'A customer admin manages and oversees specific aspects of the system, catering to customer-related functionalities and settings.',
  userDescription:
    'A user interacts with the system to perform tasks and access features based on their assigned permissions.',
  subAdminDescription:
    'A sub admin possesses restricted access and control over all system functionalities, ensuring security while granting limited permissions.',
};

export const runRepeatedlyFrequencyTypesWithValueOption = Object.freeze([
  { option: 'Minutely', value: 'minutely' },
  { option: 'Hourly', value: 'hourly' },
  { option: 'Daily', value: 'daily' },
  { option: 'Weekly', value: 'weekly' },
  { option: 'Monthly', value: 'monthly' },
]);

export const runRepeatedlyFrequencyTypes = Object.freeze({
  minutely: 'minutely',
  hourly: 'hourly',
  daily: 'daily',
  weekly: 'weekly',
  monthly: 'monthly',
});

export const runRepeatedlyFrequencies = Object.freeze([
  { label: 'Minutely', value: runRepeatedlyFrequencyTypes.minutely },
  { label: 'Hourly', value: runRepeatedlyFrequencyTypes.hourly },
  { label: 'Daily', value: runRepeatedlyFrequencyTypes.daily },
  { label: 'Weekly', value: runRepeatedlyFrequencyTypes.weekly },
  { label: 'Monthly', value: runRepeatedlyFrequencyTypes.monthly },
]);

export const monthlyFrequencyTypes = Object.freeze({
  dayWise: 'dayWise',
  dateWise: 'dateWise',
});
export const monthlyFrequencyOptions = Object.freeze([
  { value: monthlyFrequencyTypes.dayWise, option: 'Day Wise' },
  { value: monthlyFrequencyTypes.dateWise, option: 'Date Wise' },
]);

export const polingIntervalTypes = {
  hour: 'h',
  minute: 'm',
};
export const polingIntervals = [
  { value: polingIntervalTypes.hour, label: 'Hour' },
  { value: polingIntervalTypes.minute, label: 'Minute' },
];
export const emailScheduleCriteriaTypes = {
  from: 'FROM',
  to: 'TO',
  cc: 'CC',
  bcc: 'BCC',
  subject: 'SUBJECT',
  since: 'SINCE',
  before: 'BEFORE',
  on: 'ON',
};
export const emailScheduleCriteria = [
  { value: emailScheduleCriteriaTypes.from, label: 'From' },
  { value: emailScheduleCriteriaTypes.to, label: 'To' },
  { value: emailScheduleCriteriaTypes.cc, label: 'CC' },
  { value: emailScheduleCriteriaTypes.bcc, label: 'BCC' },
  { value: emailScheduleCriteriaTypes.subject, label: 'Subject' },
  { value: emailScheduleCriteriaTypes.since, label: 'Since' },
  { value: emailScheduleCriteriaTypes.before, label: 'Before' },
  { value: emailScheduleCriteriaTypes.on, label: 'On' },
];

export const controlRoomVersion = {
  version: `${process.env.REACT_APP_CONTROLROOM_VERSION}`,
};

export const tokenTypeOptions = Object.freeze([
  { label: 'Agent', value: 'agent' },
  { label: 'Bot Studio', value: 'bot studio' },
]);

export const tokenType = Object.freeze({
  agent: 'agent',
  botStudio: 'bot studio',
});

export const SubscriptionTypeValues = Object.freeze({
  MONTHLY: 'Monthly',
  ANNUALLY: 'Annually',
});

export const TIME_FILTER_VALUES = Object.freeze({
  TODAY: 'today',
  WEEKLY: 'weekly',
  MONTHLY: 'monthly',
  CUSTOM: 'custom',
});
export const CurrencyType = Object.freeze({
  INR: 'INR',
  USD: 'USD',
});
export const SubscriptionType = {
  monthly: 'Monthly',
  annually: 'Annually',
};
export const MAX_NO_OF_PROCESS = 200;
export const MAX_USER_COST_INR = 100000;
export const MAX_USER_COST_USD = 1000;

export const SUPPORT_EMAIL_ID = 'support.automationtwin@tftus.com';

export const DASHBOARD_TIME_FILTER_VALUES = Object.freeze({
  TODAY: 'today',
  WEEKLY: 'weekly',
  MONTHLY: 'monthly',
  CUSTOM: 'custom',
});

export const DASHBOARD_TIME_FILTERS = Object.freeze([
  { label: 'Today', value: DASHBOARD_TIME_FILTER_VALUES.TODAY },
  { label: 'Last 7 Days', value: DASHBOARD_TIME_FILTER_VALUES.WEEKLY },
  { label: 'Monthly', value: DASHBOARD_TIME_FILTER_VALUES.MONTHLY },
  { label: 'Custom', value: DASHBOARD_TIME_FILTER_VALUES.CUSTOM },
]);

export const noOfUsersAllowed = parseInt(process.env.REACT_APP_NO_OF_USERS_ALLOWED || '0', 10);

export const conversionAmount = parseFloat(process.env.REACT_APP_CONVERSION_RATE);

export const maxBotAllowedPerAgent = parseInt(process.env.REACT_APP_MAX_BOTS_PER_AGENT);

export const AUTH_ERRORS = Object.freeze({
  INVALID_PASSWORD_BASE: 'Invalid password',
  INVALID_EMAIL: 'Please provide valid email!',
  USER_NOT_FOUND: "Either the user doesn't exist or credentials are wrong!",
});

export const authErrorMap = Object.freeze({
  [AUTH_ERRORS.INVALID_PASSWORD_BASE]: [
    { name: 'password', errors: [AUTH_ERRORS.INVALID_PASSWORD_BASE] },
  ],
  [AUTH_ERRORS.INVALID_EMAIL]: [{ name: 'email', errors: [AUTH_ERRORS.INVALID_EMAIL] }],
  [AUTH_ERRORS.USER_NOT_FOUND]: [{ name: 'email', errors: [AUTH_ERRORS.USER_NOT_FOUND] }],
});

export const strengthLevels = [
  { label: '', color: '#D9D9D9', percent: 0 },
  { label: 'Poor', color: '#E44242', percent: 20 },
  { label: 'Weak', color: '#707070', percent: 40 },
  { label: 'Medium', color: '#F99F4A', percent: 60 },
  { label: 'Good', color: '#1493FF', percent: 80 },
  { label: 'Strong', color: '#36C565', percent: 100 },
];

export const statusConfig = Object.freeze({
  0: {
    label: 'Pending',
    color: 'var(--pending-status-color)',
    icon: <BotsMenuIcon color="white" />,
  },
  1: {
    label: 'Running',
    color: 'var(--running-status-color)',
    icon: <RunningIcon />,
  },
  2: {
    label: 'Executed',
    icon: <ActiveConfigIcon color="var(--executed-status-color)" />,
    status: 'finish',
  },
  3: {
    label: 'Error',
    color: 'var(--error-status-color)',
    icon: <ErrorIcon />,
    status: 'error',
  },
  4: {
    label: 'Cancelled',
    icon: <InActiveConfigIcon color="var(--secondary-danger-color)" />,
    status: 'error',
  },
  5: {
    label: 'Agent Disconnected',
    color: 'var(--error-status-color)',
    icon: <ErrorIcon />,
    status: 'error',
  },
});


export const simpleProcessInstructions = (
  <ul style={{ margin: 0, paddingLeft: '16px', paddingRight: 0 }}>
    <li>Repetitive, rule-based tasks like Excel/file operations.</li>
    <li>Gmail actions, basic form filling</li>
    <li>Navigating simple web/desktop UIs.</li>
  </ul>
);
export const mediumProcessInstructions = (
  <ul style={{ margin: 0, paddingLeft: '16px', paddingRight: 0 }}>
    <li>Multi-step workflows involving app integrations like Outlook or Google Drive with moderate logic and data exchange.</li>
  </ul>
);
export const complexProcessInstructions = (
  <ul style={{ margin: 0, paddingLeft: '16px', paddingRight: 0 }}>
    <li>End-to-end automation with CRM integrations.</li>
    <li>File upload/download handling.</li>
    <li>Data validations.</li>
  </ul>
);